export const PLACE_ROUTES = [
  {
    path: "placeDetailsForm",
    name: "placeDetailsForm",
    component: () =>
        import(/* webpackChunkName: "places" */ "@/modules/places/components/form/PlaceDetailsForm"),
  },
  {
    path: "routeDetailsForm",
    name: "routeDetailsForm",
    component: () =>
        import(/* webpackChunkName: "places" */ "@/modules/places/components/form/RouteDetailsForm"),
  },
    {
        path: "overview",
        name: "placeOverviewLayout",
        component: () =>
            import(/* webpackChunkName: "places" */ "@/modules/places/components/layouts/PlaceOverviewLayout"),
        children: [
            {
                path:"dashboard",
                name: "placeDashboard",
                component: () =>
                    import(/* webpackChunkName: "places" */ "@/modules/places/components/layouts/overviews/PlaceDashboardOverview")
            },
            {
                path:"placeStops",
                name: "placeStops",
                component: () =>
                    import(/* webpackChunkName: "places" */ "@/modules/places/components/layouts/overviews/PlaceStopsOverview.vue")

            }
        ]
    }

];
